import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { Outlet } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import Aside from '../../components/Aside/Aside';
import Footer from '../../components/Footer/Footer';
//import Breadcrumbs from 'react-breadcrumbs';
import { loadDriverRuns } from '../../actions/runActions';
import { loadDrivers } from '../../actions/driverActions';
import { loadTrucks } from '../../actions/truckActions';
import { loadUnmappedSuburbs } from '../../actions/suburbActions';
import DeviceLocation from '../../components/Location/DeviceLocation';
import userManager from '../../utils/userManager';
import AutoReload from '../../components/AutoReload/AutoReload';
import {FullBaseUrl, isNullEmptyOrWhitespace, ROLE_ClientUser, ROLE_Driver, ROLE_SuperUser, BASE_URL, ROLE_LocationUser, allowUserWithRoles, ROLE_Admin, ROLE_OfficeUser} from '../../constants';
import IdleTimer from 'react-idle-timer';
import {toastr} from 'react-redux-toastr';
import {loadUsers} from "../../actions/userActions";
import {loadRoles} from "../../actions/roleActions";
import { mustBeArray } from '../../utils/lib';
import {listPendingRequests} from '../../actions/clientRequestsActions';
import { push } from '../../utils/navigation';
import KioskBar from '../../components/Kiosk/KioskBar';
import NumericKeypad from '../../components/Kiosk/NumericKeypad';
import { isKioskMode } from '../../utils/kiosk';
import '../../css/kiosk.css';


class Main extends React.Component {

  constructor(props, context) {
    super(props, context);

    //TODO: inspect the URL, if id_token, then set the account.user
    this.state = {
      userName: props.account.user.userName,      
    };

    if (props.account.user.userName === '') {
      this.validateConfigAndUser();
    }

    this.time = null;
    this.reloadTime = null;

    this.onIdle = this.onIdle.bind(this);
    this.onActive = this.onActive.bind(this);
    this.tryReload = this.tryReload.bind(this);   
  }
  
  componentDidMount(){
    const {account, driverRuns, dispatch} = this.props;
    if (account.user.userName === '') {
      this.validateConfigAndUser();
    }
    
    if(!driverRuns.loaded){
      if(account && account.user && !isNullEmptyOrWhitespace(account.user.userName)) {
        this.loadRuns(true);
        if(allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser])){
          this.props.dispatch(loadDrivers());
          this.props.dispatch(loadTrucks());
        }
      }
    }
    this.props.dispatch(loadDriverRuns(false));
    this.props.dispatch(loadUnmappedSuburbs());
    this.props.dispatch(loadUsers()).then(response => {
      const usersList = mustBeArray(response && response.data);
      if(!_.isEmpty(usersList.length)){
        let userData = _.find(userList, o => o.userId === (account && account.user && account.user.id));
        if(userData && userData.forceResetPassword) return dispatch(push(`${BASE_URL}/passwordreset`));
      }
    });
    this.props.dispatch(loadRoles());    
    if(allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_ClientUser, ROLE_LocationUser])){
      this.props.dispatch(listPendingRequests({getTotal: true}));
    }
  } 
  
  validateConfigAndUser = () => {
      // A truck console can't complete a B2C sign-in — there's no keyboard and nobody to type a
      // password. Send it back to its own pairing screen instead.
      if(isKioskMode()){
        return this.props.dispatch(push(`${BASE_URL}/kiosk`));
      }
      if(!this.props.siteConfig || !this.props.siteConfig.clientId){
        return this.props.dispatch(push(`${BASE_URL}/callback`));
      }
      userManager.signinRedirect({state: window.location.pathname});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let {account,users} = this.props;
    if(account && account.user && account.user.userName !== this.state.userName){
      this.setState({userName: account.user.userName});

      if(account.user.hasRole('SuperUser')){
        this.props.dispatch(loadDrivers());
        this.props.dispatch(loadTrucks());
      }
    }
    if(!_.isEmpty(mustBeArray(users && users.items)) && 
          (mustBeArray(prevProps && prevProps.users && prevProps.users.items).length !== mustBeArray(users && users.items))){
            let userData = _.find(mustBeArray(users && users.items), o => o.userId === (account && account.user && account.user.id));
            if(userData && userData.forceResetPassword) return this.props.dispatch(push(`${BASE_URL}/passwordreset`));
          }
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

  loadRuns(showNotify){
    this.props.dispatch(loadDriverRuns(showNotify));
  }

  onActive() {
    if (this.time) {
      clearTimeout(this.time);
    }
  }

  tryReload() {
    return fetch(`${FullBaseUrl()}/index.html`, {cache: "no-store"})
      .then(response => {
        if (response.status !== 200) {
          console.log('Attempted reload, but appears offline');
          this.reloadTime = setTimeout(() => this.tryReload(), 10000);
        } else {
          clearTimeout(this.reloadTime);
          clearTimeout(this.time);
          window.location.reload(true);
        }
      })
      .catch(() => {
        console.log('Attempted reload, but appears offline');
        this.reloadTime = setTimeout(() => this.tryReload(), 10000);
      });
  }

  onIdle() {
    this.time = setTimeout(() => this.tryReload(), 30500);

    toastr.confirm(`You've been idle for a while now, click OK to prevent reload`, {
      timeOut: 30000,
      onOk: () => clearTimeout(this.time),
      onCancel: () => this.tryReload(),
      okText: 'OK',
    });
  }

  reloadApp(e) {
    e.preventDefault();
  }

  render() {
    const kiosk = isKioskMode();

    return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        activeAction={this.onActive}
        idleAction={this.onIdle}
        timeout={600000}
        format="MM-DD-YYYY HH:MM:ss.SSS">
        <div className={kiosk ? "app kiosk-mode" : "app"}>
          <AutoReload url={`${FullBaseUrl()}/index.html`} tryDelay={10*60*1000} />
          {kiosk
            ? <KioskBar />
            : <Header account={this.props.account} siteConfig={this.props.siteConfig} />}
          <div className="app-body" style={{marginTop: kiosk ? '0' : '75px'}}>
            {kiosk ? null : <Sidebar {...this.props}/>}
            <main className="main" style={{minHeight:'1024px', overflowX: 'auto'}}>
              <DeviceLocation dispatch={this.props.dispatch} />
              {/*<Breadcrumbs
                wrapperElement="ol"
                wrapperClass="breadcrumb mb-0"
                itemClass="breadcrumb-item"
                separator=""
                routes={this.props.routes}
                params={this.props.params}
              />*/}
              <div className="container pt-1">
                <Outlet />
              </div>
            </main>
            {kiosk ? null : <Aside driverRuns={this.props.driverRuns} />}
          </div>
          {kiosk ? null : <Footer siteConfig={this.props.siteConfig} />}
          {/* The console has no keyboard. Mounted once here rather than per field so the driver
              components stay as they are for the phone, where the OS keyboard does the job. */}
          {kiosk ? <NumericKeypad /> : null}
        </div>
      </IdleTimer>
    );
  }
}

Main.propTypes = {
  account: PropTypes.object.isRequired,
  driverRuns: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps){
  return {
    driverRuns: state.driverRuns,
    account: state.account,
    siteConfig: state.apiConfig,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);
